var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9C9.9125 9 10.2656 8.85313 10.5594 8.55938C10.8531 8.26563 11 7.9125 11 7.5C11 7.0875 10.8531 6.73438 10.5594 6.44063C10.2656 6.14688 9.9125 6 9.5 6C9.0875 6 8.73438 6.14688 8.44063 6.44063C8.14688 6.73438 8 7.0875 8 7.5C8 7.9125 8.14688 8.26563 8.44063 8.55938C8.73438 8.85313 9.0875 9 9.5 9ZM9.5 14.5125C11.025 13.1125 12.1562 11.8406 12.8938 10.6969C13.6313 9.55313 14 8.5375 14 7.65C14 6.2875 13.5656 5.17188 12.6969 4.30313C11.8281 3.43438 10.7625 3 9.5 3C8.2375 3 7.17188 3.43438 6.30313 4.30313C5.43438 5.17188 5 6.2875 5 7.65C5 8.5375 5.36875 9.55313 6.10625 10.6969C6.84375 11.8406 7.975 13.1125 9.5 14.5125ZM9.5 16.5C7.4875 14.7875 5.98438 13.1969 4.99063 11.7281C3.99688 10.2594 3.5 8.9 3.5 7.65C3.5 5.775 4.10312 4.28125 5.30938 3.16875C6.51563 2.05625 7.9125 1.5 9.5 1.5C11.0875 1.5 12.4844 2.05625 13.6906 3.16875C14.8969 4.28125 15.5 5.775 15.5 7.65C15.5 8.9 15.0031 10.2594 14.0094 11.7281C13.0156 13.1969 11.5125 14.7875 9.5 16.5Z",
    fill: "#6710A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.008a5461d213eb4537a2774473a0c981.svg";
export { ForwardRef as ReactComponent };